var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56231 13.156C5.7846 13.156 5.09282 12.658 4.84161 11.9167L4.82462 11.8608C4.76538 11.6645 4.74056 11.4994 4.74056 11.3342V8.02197L3.56203 11.956C3.41046 12.5346 3.75586 13.1345 4.33539 13.2944L11.8473 15.3061C11.9411 15.3304 12.0348 15.342 12.1272 15.342C12.611 15.342 13.0531 15.0209 13.177 14.5477L13.6146 13.156H6.56231Z",
    fill: "url(#paint0_linear_1_1653)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89839 8.05409C8.43423 8.05409 8.86992 7.61832 8.86992 7.08247C8.86992 6.54662 8.43423 6.11084 7.89839 6.11084C7.36254 6.11084 6.92676 6.54662 6.92676 7.08247C6.92676 7.61832 7.36254 8.05409 7.89839 8.05409Z",
    fill: "url(#paint1_linear_1_1653)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9702 4.65479H6.68322C6.01385 4.65479 5.46875 5.19989 5.46875 5.86934V11.2131C5.46875 11.8825 6.01385 12.4276 6.68322 12.4276H13.9702C14.6397 12.4276 15.1848 11.8825 15.1848 11.2131V5.86934C15.1848 5.19989 14.6397 4.65479 13.9702 4.65479ZM6.68322 5.62641H13.9702C14.1043 5.62641 14.2131 5.7352 14.2131 5.86934V9.31803L12.6785 7.52733C12.5157 7.33643 12.2801 7.23441 12.027 7.22862C11.7754 7.23005 11.5393 7.34177 11.378 7.53515L9.57373 9.70079L8.98593 9.11441C8.65369 8.78218 8.11295 8.78218 7.78116 9.11441L6.44038 10.4548V5.86934C6.44038 5.7352 6.54917 5.62641 6.68322 5.62641Z",
    fill: "url(#paint2_linear_1_1653)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1653",
    x1: 28.0514,
    y1: 23.8312,
    x2: -4.14631,
    y2: 36.5302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135781,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1653",
    x1: 11.6507,
    y1: 10.3077,
    x2: 5.02661,
    y2: 12.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135781,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1653",
    x1: 29.0888,
    y1: 21.4419,
    x2: -2.67925,
    y2: 32.8062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135781,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.702fc1b41b1603de72c02d8c289ce32f.svg";
export { ForwardRef as ReactComponent };